import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { BarContextProvider } from "@/components/BannerSlider/components/controls/components/progressBar/components/bar/context/bar.context";
import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";
import { TimerStatus } from "@/utils/hooks/timer/useTimer.types";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { index } = useMapped();
    const { activeIndex, slideTo, stopTimer, status } =
        useBannerSliderContext();

    const isActiveIndex = index === activeIndex;

    const isRunning = status === TimerStatus.Running && isActiveIndex;
    const isStopped =
        status === TimerStatus.Stopped || status === TimerStatus.Initial;
    const isActive = isActiveIndex && status !== TimerStatus.Initial;

    const { controls_progressBar_bar } = bannerSlider();

    return (
        <BarContextProvider
            isRunning={isRunning}
            isStopped={isStopped}
            isActive={isActive}
        >
            <Button
                size={"sm"}
                color={"transparent"}
                className={controls_progressBar_bar({
                    isRunning: isRunning,
                    className: className
                })}
                onClick={() => {
                    stopTimer();
                    slideTo(index);
                }}
            >
                {children}
            </Button>
        </BarContextProvider>
    );
};
